import VariationTableHelper from "./variation-table-helper";

const VariationHelpers = {
  TableMain: VariationTableHelper,
};

export default VariationHelpers;
